module.exports = __webpack_public_path__ + "static/media/line.bd712d2a.png";